import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import ua from '@tencent/docs-user-agent'; // 苹果系设备用 Command 键

var isMacOS = ua.isMac || ua.isIPad;
/**
 * 判断是否按下了 Ctrl 键
 */

var CtrlKeyManager = /*#__PURE__*/function () {
  function CtrlKeyManager() {
    var _this = this;

    _classCallCheck(this, CtrlKeyManager);

    _defineProperty(this, "isPressed", false);

    _defineProperty(this, "handleKeyboardEvent", function (e) {
      if (e.key !== (isMacOS ? 'Meta' : 'Control')) {
        return;
      }

      _this.setCtrlKeyStatus(e.type === 'keydown');
    });

    _defineProperty(this, "handleBlurEvent", function () {
      _this.setCtrlKeyStatus(false);
    });

    var events = ['keydown', 'keyup'];

    if (typeof window === 'undefined' || typeof document === 'undefined') {
      console.debug('CtrlKeyManager skip init, window or document is undefined');
      return;
    }

    events.forEach(function (evt) {
      document.addEventListener(evt, _this.handleKeyboardEvent);
    });
    window.addEventListener('blur', this.handleBlurEvent); // Clean up

    window.addEventListener('beforeunload', function () {
      events.forEach(function (evt) {
        document.removeEventListener(evt, _this.handleKeyboardEvent);
      });
      window.removeEventListener('blur', _this.handleBlurEvent);
    });
  }

  _createClass(CtrlKeyManager, [{
    key: "setCtrlKeyStatus",
    value: function setCtrlKeyStatus(isPressed) {
      this.isPressed = isPressed;
    }
  }]);

  return CtrlKeyManager;
}();

export default new CtrlKeyManager();